import { render, staticRenderFns } from "./ArticleTools.vue?vue&type=template&id=fcb60f34&"
import script from "./ArticleTools.vue?vue&type=script&lang=js&"
export * from "./ArticleTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports